import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import MUIRichTextEditor from 'mui-rte'
import { convertToRaw } from 'draft-js'
import buildValidUrlFromContentState from 'lib/rte-utils/build-valid-url'
import RecommendedDetailsDialog, {
  eventRecommendationsConfig,
} from 'components/recommended-event-details-dialog'
import { useStyles } from '../styles'

const EventDescription = () => {
  const { register, setValue, getValues } = useFormContext()
  const [isOpen, setIsOpen] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    register('description')
  }, [register])

  const defaultValue = getValues('description')

  return (
    <Box width="100%" minWidth={0} className={classes.fieldGroup}>
      <Typography className={classes.sectionHeading}>Description</Typography>
      <div className={classes.editorRoot}>
        <MUIRichTextEditor
          className={classes.editor}
          label="Enter your event description..."
          controls={['title', 'bold', 'italic', 'bulletList', 'link']}
          defaultValue={defaultValue}
          onChange={value => {
            const content = JSON.stringify(
              buildValidUrlFromContentState(
                convertToRaw(value.getCurrentContent()),
              ),
            )
            setValue('description', content)
          }}
        />
      </div>
      <Button onClick={() => setIsOpen(true)}>Recommended event details</Button>
      <RecommendedDetailsDialog
        title="Recommended event details"
        recommendations={eventRecommendationsConfig}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </Box>
  )
}

export default EventDescription
